export const PRODUCT_I18N_KEYS = {
  vertical: '垂直种植系统',
  hydroponics: '无土栽培',
  led: 'LED人工光',
  ai_env: 'AI环境控制',
  irrigation: '精准灌溉/营养液',
  sensors: '传感器+数据系统',
  automation: '自动化生产',
  breeding: '植物算法/育种',
  basic: '基础算力',
  advanced: '高级算力',
  premium: '超级算力',
  super: '超级算力',
  enterprise: '企业算力'
}

export function productDisplayName(type, t, setting) {
  if (setting && setting.name) return setting.name
  const key = PRODUCT_I18N_KEYS[type]
  if (key && typeof t === 'function') return t(`computing.${key}`)
  return type || ''
}

export function isZhLocale(locale) {
  return String(locale || '').toLowerCase().startsWith('zh')
}

export function localizedProductName(item, locale) {
  if (!item) return ''
  const zh = item.name_zh || item.product_name_zh || item.name || item.product_name || ''
  const en = item.name_en || item.product_name_en || item.nameEn || zh
  return isZhLocale(locale) ? zh : (en || zh)
}

export function localizedProductDesc(item, locale) {
  if (!item) return ''
  const zh = item.description_zh || item.description || ''
  const en = item.description_en || item.descriptionEn || zh
  return isZhLocale(locale) ? zh : (en || zh)
}

export function circledNum(sortOrder, index = 0) {
  const n = Number(sortOrder) > 0 ? Number(sortOrder) : index + 1
  const marks = ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧']
  return marks[n - 1] || String(n)
}
